module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fixed-container",
    staticStyle: {
      "padding-top": "60px",
      "position": "relative"
    }
  }, [_c('mt-fixed-container', {
    attrs: {
      "bottom": "20px",
      "left": "20px"
    }
  }, [_c('mt-button', [_vm._v("按钮3")]), _vm._v(" "), _c('mt-button', [_vm._v("按钮4")])], 1), _vm._v(" "), _c('mt-fixed-container', {
    attrs: {
      "position": "top",
      "top": "100px",
      "right": "20px",
      "left": "inherit"
    }
  }, [_c('mt-button', [_vm._v("按钮3")]), _vm._v(" "), _c('mt-button', [_vm._v("按钮4")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf0edcb6","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/fixed-container.vue
// module id = 527
// module chunks = 0